import { Foundation } from '@models';
export interface SearchFoundationsResult {
  searchProjects: Foundation[];
}
